import $ from 'jquery'

import colors from '../../../../lib/colors'

import buffered from './buffered/buffered'
import markers from './markers/markers'
import cursor from './cursor/cursor'

export default function(o){

  var bufferedDiv = buffered(o)
  var markersDiv = markers(o)
  var cursorDiv = cursor(o)

  var set = function(roll){
    if(roll){
      markersDiv.set(roll)
    } else {
      markersDiv.set()
    }
    bufferedDiv.reset()
  }

  var setSequence = function(sequence){
    markersDiv.reset()
    bufferedDiv.reset()
  }

  var seek = function(left){
    var length = o.video.duration
    var time = Math.round(left / 400 * length)
    o.video.currentTime = time
    o.loopStart = time
    o.player.setFilter()
  }

  var scrubbing = false
  var start = function(e){
    if(o.video){
      o.controls.stop.click()
      scrubbing = true
      seek(e.clientX)
    }
    e.preventDefault()
  }

  var move = function(e){
    if(o.video && scrubbing){
      seek(e.clientX)
    }
    e.preventDefault()
  }

  var stop = function(e){
    if(o.video && scrubbing){
      scrubbing = false
    }
    e.preventDefault()
  }

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      background: 'rgba(255,255,255,.15)',
      width: '400px',
      height: '34px',
      top: '300px',
      left: 0,
      overflow: 'hidden',
      borderBottom: `1px solid ${colors.black}`,
    })
    .append([
      bufferedDiv,
      cursorDiv,
      markersDiv,
    ])
    .mousedown(start)
    .mousemove(move)
    .mouseup(stop)
    .mouseout(stop)

  div.set = set
  div.setSequence = setSequence

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/timeline/timeline.js